var React = require('react');

function Trophy (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","opacity":"1"},[React.createElement("path",{"fill":"currentColor","d":"M31.667 8.333h-3.334V5H11.667v3.333H8.333C6.5 8.333 5 9.833 5 11.667v1.666c0 4.25 3.2 7.717 7.317 8.234 1.07 2.535 3.32 4.38 6.016 4.933v5.167h-6.666V35h16.666v-3.333h-6.666V26.5c2.696-.552 4.946-2.398 6.016-4.933C31.8 21.05 35 17.583 35 13.333v-1.666c0-1.834-1.5-3.334-3.333-3.334zm-23.334 5v-1.666h3.334v6.366c-1.934-.7-3.334-2.533-3.334-4.7zm11.667 10c-2.75 0-5-2.25-5-5v-10h10v10c0 2.75-2.25 5-5 5zm11.667-10c0 2.167-1.4 4-3.334 4.7v-6.366h3.334v1.666z","key":0}),React.createElement("path",{"fillRule":"nonzero","d":"M0 0H40V40H0z","key":1})]));
}

Trophy.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40"};

module.exports = Trophy;

Trophy.default = Trophy;
